/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyExternalOrders } from 'app/entities/pharmacy-external-order/pharmacy-external-order.reducer';
import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-external-order-item.reducer';

export const PharmacyExternalOrderItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyExternalOrders = useAppSelector(state => state.pharmacyExternalOrder.entities);
  const pharmacyExternalOrderItemEntity = useAppSelector(state => state.pharmacyExternalOrderItem.entity);
  const loading = useAppSelector(state => state.pharmacyExternalOrderItem.loading);
  const updating = useAppSelector(state => state.pharmacyExternalOrderItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyExternalOrderItem.updateSuccess);
  const pharmacyIndentStatusValues = Object.keys(PharmacyIndentStatus);
  const pharmacyProductTypeValues = Object.keys(PharmacyProductType);

  const handleClose = () => {
    navigate(`/pharmacy-external-order-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyExternalOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.orderedQty !== undefined && typeof values.orderedQty !== 'number') {
      values.orderedQty = Number(values.orderedQty);
    }
    if (values.fulfilledQty !== undefined && typeof values.fulfilledQty !== 'number') {
      values.fulfilledQty = Number(values.fulfilledQty);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyExternalOrderItemEntity,
      ...values,
      order: pharmacyExternalOrders.find(it => it.id.toString() === values.order?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          itemStatus: 'REQUESTED',
          productType: 'CONSUMABLE',
          ...pharmacyExternalOrderItemEntity,
          order: pharmacyExternalOrderItemEntity?.order?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyExternalOrderItem.home.createOrEditLabel" data-cy="PharmacyExternalOrderItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderItem.home.createOrEditLabel">
              Create or edit a PharmacyExternalOrderItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-external-order-item-id"
                  label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.itemStatus')}
                id="pharmacy-external-order-item-itemStatus"
                name="itemStatus"
                data-cy="itemStatus"
                type="select"
              >
                {pharmacyIndentStatusValues.map(pharmacyIndentStatus => (
                  <option value={pharmacyIndentStatus} key={pharmacyIndentStatus}>
                    {translate(`tinyMedicRestApp.PharmacyIndentStatus.${pharmacyIndentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.orderedQty')}
                id="pharmacy-external-order-item-orderedQty"
                name="orderedQty"
                data-cy="orderedQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.fulfilledQty')}
                id="pharmacy-external-order-item-fulfilledQty"
                name="fulfilledQty"
                data-cy="fulfilledQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.packs')}
                id="pharmacy-external-order-item-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.productType')}
                id="pharmacy-external-order-item-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {pharmacyProductTypeValues.map(pharmacyProductType => (
                  <option value={pharmacyProductType} key={pharmacyProductType}>
                    {translate(`tinyMedicRestApp.PharmacyProductType.${pharmacyProductType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.productId')}
                id="pharmacy-external-order-item-productId"
                name="productId"
                data-cy="productId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.active')}
                id="pharmacy-external-order-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.cursor')}
                id="pharmacy-external-order-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.lastUpdated')}
                id="pharmacy-external-order-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.microSec')}
                id="pharmacy-external-order-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.timestampEntry')}
                id="pharmacy-external-order-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-external-order-item-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.pharmacyExternalOrderItem.order')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyExternalOrders
                  ? pharmacyExternalOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-external-order-item"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyExternalOrderItemUpdate;
